var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnWrong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#EF5144"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.857 5.00001C5.62031 4.76332 5.23655 4.76332 4.99986 5.00001C4.76317 5.23671 4.76317 5.62046 4.99986 5.85716L7.14272 8.00001L4.99986 10.1429C4.76317 10.3796 4.76317 10.7633 4.99986 11C5.23655 11.2367 5.62031 11.2367 5.857 11L7.99986 8.85716L10.1427 11C10.3794 11.2367 10.7632 11.2367 10.9999 11C11.2366 10.7633 11.2366 10.3796 10.9999 10.1429L8.857 8.00001L10.9999 5.85716C11.2366 5.62046 11.2366 5.23671 10.9999 5.00001C10.7632 4.76332 10.3794 4.76332 10.1427 5.00001L7.99986 7.14287L5.857 5.00001Z",
    fill: "#EF5144"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWrong);
export default __webpack_public_path__ + "static/media/icn_wrong.bd14a86c65d5bda84c000316759e23ff.svg";
export { ForwardRef as ReactComponent };